<template>
  <div id="footer" class="container-fluid">
    <p class="address_tel_fax">
      <span>邮箱：<a class="email_wx" href="mailto:zhangmengdie@lynwoo.cn">zhangmengdie@lynwoo.cn</a></span>
    </p>
    <p class="copy">Copyright &copy; 版权所有2017-2021 杭州灵羽科技有限公司 | <a class = "email_wx" target="_blank" href="https://beian.miit.gov.cn/"> 浙ICP备2021027509号</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
  margin-top: 30px;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
  text-decoration: none;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /* margin: 50px 0 10px; */
}
@media screen and (max-width: 997px) {
    .title {
      font-size: 20px;
    }
    .address_tel_fax {
      font-size: 12px;
    }
    .email_wx {

    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue